import styled from "styled-components";
import { ReactComponent as CheckIcon_ } from "../../../assets/check.svg";


export const IconImg = styled.img`
    margin-left: 8px;
    margin-bottom: 20px;
    cursor: pointer;
    width: 24px;
    height: 24px;
    &:hover {
        margin-left: 12px;
        transform: scale(1.2);
        transition: all 0.2s ease-in-out;
    }
`
export const CheckIcon = styled(CheckIcon_)`
    /* margin-left: 5px; */
    circle{
        fill: #96da96;
    }
    path{
        fill: #036403;
    }
    margin-left: 8px;
    margin-bottom: 20px;
`
